import { render, staticRenderFns } from "./ModalEditUserData.vue?vue&type=template&id=377b6f4a&scoped=true&lang=pug&"
import script from "./ModalEditUserData.vue?vue&type=script&lang=ts&"
export * from "./ModalEditUserData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b6f4a",
  null
  
)

export default component.exports